export default {
  methods: {
    /**
     *
     * @param {*} func Function Active
     * @param {*} delay Time wait
     */
    pgtDebounce (func, delay) {
      let debounceTimer
      return function () {
        // console.log('debouncing call..')
        const context = this
        const args = arguments
        clearTimeout(debounceTimer)
        debounceTimer = setTimeout(() => func.apply(context, args), delay)
        // console.log('..done')
      }
    },
    parseDotNotation (jsonobj) {
      function recurse (str, val, obj) {
        var currentObj = obj
        var keys = str.split('.')
        var i
        var l = Math.max(1, keys.length - 1)
        var key

        for (i = 0; i < l; ++i) {
          key = keys[i]
          currentObj[key] = currentObj[key] || {}
          currentObj = currentObj[key]
        }

        currentObj[keys[i]] = val
        delete obj[str]
      }
      for (var key in jsonobj) {
        if (key.indexOf('.') !== -1) {
          recurse(key, jsonobj[key], jsonobj)
        }
      }
      return jsonobj
    },
    objectToDotNotation (jsonobj, prefix) {
      var newobj = {}
      function recurse (o, p, isArrayItem) {
        for (var f in o) {
          if (o[f] && typeof o[f] === 'object') {
            if (Array.isArray(o[f])) { newobj = recurse(o[f], (p ? p + '.' : '') + f, true) }
            // array
            else {
              if (isArrayItem) newobj = recurse(o[f], (p || '') + '[' + f + ']')
              // array item object
              else newobj = recurse(o[f], (p ? p + '.' : '') + f) // object
            }
          } else {
            if (isArrayItem) newobj[p + '[' + f + ']'] = o[f]
            // array item primitive
            else newobj[p + '.' + f] = o[f] // primitive
          }
        }
        return newobj
      }
      return recurse(jsonobj, prefix)
    }
  }
}
